export default __webpack_public_path__ + "static/media/yoru_new.b9e48d70.png";